import {
  gridSizeMdLg2, gridSizeMdLg12,
  hasPermission,
  formatDate,
  gridSizeMdLg4,
} from "@/shared"
import {
  getProductoSimple,
} from "@/shared/actions/erp"
import { IDataMovimientoInventario, IDataProducto } from "@/shared/interfaces"
import { Button, Grid } from "@mui/material"
import { useCallback } from "react"
import { GeneralTable } from "@/shared/components/ui"
import { Refresh, Search } from "@mui/icons-material"
import DeleteIcon from '@mui/icons-material/Delete';
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch"
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm"
import useKardexByBodega from "../hook/useKardeByBodega"
import { PiMicrosoftExcelLogoFill } from "react-icons/pi"
import { PermissionsEnum } from "@/auth/interfaces"
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker"

export default function KardexPorProducto() {

  const {
    form,
    setEnabled,
    enabled,
    setFilterObject,
    columnBase,
    dataKardex,
    isLoadingKardex,
    isRefetchingKardex,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    downloadKardexExcel,
    refetch,
    flatpickrRef,
  } = useKardexByBodega()

  ///* form

  /* const form = useForm<KardexPorProductoForm>({
    defaultValues: {
    }
  }); */

  const {
    reset,
    control,
  } = form;


  const {
    fetchAutocompleteProducto
  } = useAutocompleteFetch()

  ///* fetch
  /* const {
    data: dataKardex,
    isLoading: isLoadingKardex,
    isRefetching: isRefetchingKardex
  } = useFetchMovimientoInventario({
    params: {
      ...form.getValues(),
      producto: producto !== 'TODOS' ? producto : null,
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false
    },
    enabled: enabled
  }); */

  const onChangeValue = useCallback((value: any) => {
    setEnabled(false)
    reset({
      ...form.getValues(),
      producto: value,
      estado: false
    })

  }, []);

  return (
    <Grid container spacing={3}
      //justifyContent={'space-between'}
      alignItems={'center'} >

      <CustomAutocompleteFetchForm<IDataProducto>
        required={false}
        size={gridSizeMdLg4}
        control={control}
        name="producto"
        label="Codigo producto"
        getOptionLabel={(opt) => `${opt.codigo}` || ''}
        key={'autocomplete-producto'}
        getOptionKey={(opt) => opt.codigo}
        initialInputValue={form.getValues().producto ?? ''}
        onChangeValue={onChangeValue}
        ///* fetch
        keySearch="codigo"
        isAll
        fetchData={fetchAutocompleteProducto}
        loadOptionByValue={async (cod) => {

          const resp = await getProductoSimple({
            codigo: cod as string
          })

          return resp.data.data[0] ?? null
        }}

      />

      <CustomAutocompleteFetchForm<IDataProducto>
        control={control}
        required={false}
        size={gridSizeMdLg4}
        name="descripcion_producto"
        label="Descripción producto"
        fetchData={fetchAutocompleteProducto}
        keySearch="descripcion"
        getOptionLabel={(opt) => `${opt.descripcion}` || ''}
        key={'autocomplete-producto'}
        getOptionKey={(opt) => opt.descripcion}
        //isAll={true}
        onChangeValue={() => {
          setEnabled(false);

        }}
      />

      <DateRangePicker
        size={gridSizeMdLg4}
        flatpickrRef={flatpickrRef}
        defaultValue={[form.getValues().fecha_creacion_after, form.getValues().fecha_creacion_before]}
        onChange={(range) => {
          console.log(range);
          setEnabled(false);

          if (range.length == 2) {
            reset({
              ...form.getValues(),
              fecha_creacion_after: formatDate(range[0]),
              fecha_creacion_before: formatDate(range[1])
            })

          }

        }}
      />

      <Grid item
        container
        {...gridSizeMdLg12}
        justifyContent={'end'}
        spacing={3}
      >

        <Grid item {...gridSizeMdLg2}>
          <Button
            fullWidth
            size="small"
            startIcon={<Search />}
            variant="contained"
            onClick={() => {
              reset({
                ...form.getValues(),
                estado: true
              })
              setEnabled(true)
            }}
          >
            Buscar
          </Button>
        </Grid>

        <Grid item {...gridSizeMdLg2}>
          <Button
            fullWidth
            size="small"
            variant="outlined"
            startIcon={<DeleteIcon />}
            onClick={() => {
              reset({
                estado: false
              })
              setFilterObject({})
              setEnabled(false)
            }}
          >
            Limpiar
          </Button>
        </Grid>

        <Grid item {...gridSizeMdLg2}>
          <Button
            fullWidth
            size="small"
            variant="outlined"
            startIcon={<Refresh />}
            onClick={() => {
              refetch()
            }}
          >
            Actualizar
          </Button>
        </Grid>
        {
          hasPermission(PermissionsEnum.kardex_descargar_excel) &&
          <Grid item {...gridSizeMdLg2}>
            <Button
              fullWidth
              startIcon={<PiMicrosoftExcelLogoFill />}
              variant="contained"
              color="success"
              size="small"
              onClick={() => {
                downloadKardexExcel()
              }}
            >
              EXCEL
            </Button>
          </Grid>
        }


      </Grid>

      <Grid item {...gridSizeMdLg12}>

        <GeneralTable<IDataMovimientoInventario>
          columns={columnBase}
          data={
            enabled
              ? dataKardex?.data.data || []
              : []}
          //
          isLoading={isLoadingKardex}
          isRefetching={isRefetchingKardex}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataKardex?.data?.count}
          // // actions
          actionsColumnSize={120}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          enableColumnActions={true}

          // crud
          enableEditing={false}
          positionActionsColumn='first'
        />
      </Grid>


    </Grid>
  )

}
